import { LessonResult } from '@yandex-int/k-common/typings';

import * as constants from './constants';

export const getStudentResultRequest = (clessonId: number, studentId: number) =>
    <const>{
        type: constants.GET_STUDENT_CLESSON_RESULT_REQUEST,
        clessonId,
        studentId,
    };

export const getStudentResultSuccess = (clessonId: number, studentId: number, result: LessonResult) =>
    <const>{
        type: constants.GET_STUDENT_CLESSON_RESULT_SUCCESS,
        clessonId,
        studentId,
        result,
    };

export const getStudentResultError = () =>
    <const>{
        type: constants.GET_STUDENT_CLESSON_RESULT_ERROR,
    };

export const clear = (clessonId: number) =>
    <const>{
        type: constants.CLEAR,
        clessonId,
    };
